import React from 'react';
import { cn } from '../../lib/cn';

export const Badge = ({ variant = 'surface', className, children, ...props }) => {
  return (
    <span
      className={cn('ds-badge', `ds-badge--${variant}`, className)}
      {...props}
    >
      {children}
    </span>
  );
};
